import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "td__store-name" };
const _hoisted_2 = { class: "td__ceo-name" };
const _hoisted_3 = { class: "td__business-number" };
const _hoisted_4 = { class: "td__store-address" };
const _hoisted_5 = { class: "td__business-type" };
const _hoisted_6 = { class: "td__business-condition" };
const _hoisted_7 = { class: "td__ceo-email" };
const _hoisted_8 = { class: "td__order-count" };
const _hoisted_9 = { class: "td__total-amount" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("tr", {
        onClick: _cache[0] || (_cache[0] =
            //@ts-ignore
            (...args) => (_ctx.handleClickRow && _ctx.handleClickRow(...args)))
    }, [
        _createCommentVNode(" 상점명 "),
        _createElementVNode("td", _hoisted_1, [
            _createElementVNode("span", null, _toDisplayString(_ctx.store.storeName), 1 /* TEXT */)
        ]),
        _createCommentVNode(" 대표자명 "),
        _createElementVNode("td", _hoisted_2, _toDisplayString(_ctx.store.validatedCeoName), 1 /* TEXT */),
        _createCommentVNode(" 사업자 등록번호 "),
        _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.store.validatedBusinessNumber), 1 /* TEXT */),
        _createCommentVNode(" 사업장 주소 "),
        _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.storeAddress), 1 /* TEXT */),
        _createCommentVNode(" 종목 "),
        _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.store.validatedBusinessType), 1 /* TEXT */),
        _createCommentVNode(" 업태 "),
        _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.store.validatedBusinessCondition), 1 /* TEXT */),
        _createCommentVNode(" 이메일 "),
        _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.store.validatedCeoEmail), 1 /* TEXT */),
        _createCommentVNode(" 완료 건 수 "),
        _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.store.orderCount) + " " + _toDisplayString(_ctx.$t('common.count')), 1 /* TEXT */),
        _createCommentVNode(" 총액 "),
        _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.totalAmount), 1 /* TEXT */)
    ]));
}
